import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { HOME_PATH } from "../utils/textRoutes";

/** navigate(-1) when history exists; else fallback route. */
export function useSmartBack(fallback = HOME_PATH) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
      return;
    }
    if (location.key && location.key !== "default") {
      navigate(-1);
      return;
    }
    navigate(fallback, { replace: false });
  }, [navigate, location.key, fallback]);
}
